import { isString } from "../Utils/String";

const PREFIX = `CHUB`;

export const STORAGE_KEYS = {
  FILTER_EXPRESSION: `FILTER_EXPRESSION`,
  FILTER_KEY: `FILTER_KEY`,
  LANGUAGE: `LANGUAGE`,
  USERNAMES: `USERNAMES`,
  TOOLBAR_ONLY_ICONS: `TOOLBAR_ONLY_ICONS`,
  REFRESH_EVERY_TIME: `REFRESH_EVERY_TIME`,
  NOT_MERGED_PROJECTS: `NOT_MERGED_PROJECTS`,
  THEME_CONFIG: `THEME_CONFIG`
};

let storage = null;
function safeGetStorage(): Storage {
  if (storage == null) {
    if (typeof window !== `undefined`) {
      storage = window?.localStorage ?? lsFallback();
    } else {
      storage = lsFallback();
    }
  }
  return storage;
}

export function save<T>(key: string, value: T): boolean {
  try {
    safeGetStorage().setItem(keyBuilder(key), JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
}

export function get<T>(key: string): T {
  const item = safeGetStorage().getItem(keyBuilder(key));

  try {
    if (isString(item)) {
      return JSON.parse(item) as T;
    }
  } catch {
    /* ignore */
  }

  return null;
}

export function remove(key: string): boolean {
  try {
    safeGetStorage().removeItem(keyBuilder(key));
    return true;
  } catch {
    return false;
  }
}

export function clearLocalStorage(): boolean {
  try {
    if (remove(STORAGE_KEYS.FILTER_EXPRESSION) && remove(STORAGE_KEYS.LANGUAGE)) {
      return true;
    }
    return false;
  } catch {
    return false;
  }
}

function lsFallback() {
  return {
    getItem() {
      warn();
    },
    setItem() {
      warn();
    },
    removeItem() {
      warn();
    }
  };
}

function keyBuilder(key: string): string {
  return `${PREFIX}_${key}`;
}

function warn(message = `LocalStorage not available.`) {
  console.warn(message);
}
